<template>
  <el-col class="displayLayout" id="quotationManagement">
    <template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="报价单状态">
          <el-select v-model="formInline.status" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="待投保" value="0"></el-option>
            <el-option label="已转投保" value="1"></el-option>
            <el-option label="已失效" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报价提交日期">
          <el-date-picker
            v-model="formInline.quotationDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSelect">搜索</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%;"
        v-loading="loading">
        <el-table-column prop="number"
                         width="150"
                         label="报价单编号">
        </el-table-column>
        <el-table-column prop="name"
                         label="产品名称">
        </el-table-column>
        <el-table-column prop="createTime"
                         width="160"
                         label="报价单提交日期">
        </el-table-column>
        <el-table-column prop="status"
                         width="100"
                         label="报价单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status==0">待投保</div>
            <div v-if="scope.row.status==1">已转投保</div>
            <div v-if="scope.row.status==-1">已失效</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="onSee(scope.row)">查看</el-button>
            <el-button size="mini" @click="editQuote(scope.row)" v-if="scope.row.status == 0 && insType != '5'">编辑</el-button>
            <el-button size="mini" @click="changeOrder(scope.row)" v-if="scope.row.status == 0 && insType != '5'">转投保</el-button>
            <el-button size="mini" @click="handleQuoteMain(scope.row)" v-if="scope.row.status == -1">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getQuotationList"
        :current-page.sync="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-col>
</template>

<script>
  export default {
    name: "quotationManagement",
    data() {
      return {
        loading:false,
        page: 1,
        total: 0,
        pageSize: 10,
        tableData: [],
        formInline: {
          status: '',
          quotationDate: '',
        },
        insType: null,
      }
    },
    watch: {
      '$route'() {
        this.getQuotationList();
      }
    },
    methods: {
      /**
       * 查看
       * @param row
       */
      onSee(row){
        let that = this,
          {quoteIdNum} = row;

        if (that.insType == '5'){
          that.$router.push({path: '/taiKang/fillInfo', query: {quoteIdNum}});
        }else {
          that.$router.push({
            name: 'quotationDetails',
            params: { quoteMainId: row.id, userMember: row.userMember },
          });
        }
      },
      //-- 删除
      handleQuoteMain(row){
        let that = this;
        that.$$.confirm({
          message: '确定删除？',
          onOk: function () {
            that.axios.post('/management/quotemaininfo/handlerQuoteMain?id='+row.id, {}).then((response) => {
              let data = response.data;
              if(data.success){
                that.getQuotationList();

                that.$message.success("删除成功!");
              }
            })
          }
        });
      },
      //-- 编辑
      editQuote(row){
        this.getQuoteDetailListByMainId(row, 1);
      },
      //-- 转投保
      changeOrder(row){
        this.getQuoteDetailListByMainId(row, 2);
      },
      //-- 获取报价书数据 type: 1-编辑，2-转投保
      getQuoteDetailListByMainId(row, type) {
        this.loading = true;
        this.axios.post('/management/quotedetailinfo/getQuoteDetailListByMainId', {
          quoteMainId: row.id,
          userMember: row.userMember,
        }).then((response) => {
          let data = response.data;
          if(data.success){
            let dynamicValidateForm = {};
            let cards = [];
            dynamicValidateForm.companyName = data.quoteMainInfo.holderName;
            dynamicValidateForm.quoteMainNum = data.number;
            dynamicValidateForm.quoteMainId = row.id;
            dynamicValidateForm.userMember = row.userMember;
            dynamicValidateForm.projectName = row.name;
            data.quoteDetailList.forEach(item => {
              let cardsMap = {};
              cardsMap.groupSize = item.groupSize;
              cardsMap.occOneId = item.oneId;
              cardsMap.occTwoId = item.twoId;
              cardsMap.occThreeId = item.threeId;
              cardsMap.skuId = item.skuId;
              cards.push(cardsMap);
            });
            dynamicValidateForm.cards = cards;

            //-- 会话存储 - 参数
            sessionStorage.setItem('dynamicValidateForm', JSON.stringify(dynamicValidateForm));

            this.axios.post('/management/skuproduct/'+ dynamicValidateForm.cards[0].skuId).then((response) => {
              let data = response.data.datas;
              console.log(data);
              if (type == 1){
                this.$router.push({name: 'insureManagement', query: {productId: data.productId, planId: data.planId }});
              }else if (type == 2){
                //-- 会话存储 - 参数
                sessionStorage.removeItem('allData'); // 清理填写资料缓存
                this.$router.push({name: 'insureDetails' , query: {productId: data.productId, planId: data.planId }});
              }

            });

          }
          this.loading = false;
        })
      },
      handleSizeChange(val) {
        this.page = 1;
        this.pageSize = val;
        this.getQuotationList();
      },
      onSelect(){
        this.page = 1;
        this.getQuotationList();
      },
      getQuotationList() {
        let insType = this.$route.query.insType;
        this.insType = this.$$.isValidObj(insType) ? insType : null;

        let params = {
          status: this.formInline.status==''?null:this.formInline.status,
          type: 27,
          createTimeBegin: this.formInline.quotationDate[0],
          createTimeEnd: this.formInline.quotationDate[1],
        };
        if (this.$$.isValidObj(this.insType)) params['insType'] = this.insType;

        this.loading = true;
        this.axios.post('/management/quotemaininfo/getQuoteMainByMemberId?_pageSize='+this.pageSize+'&_current='+this.page, params).then((response) => {
          let data = response.data;
          if (data.success) {
            let {list, pagination } = data.datas;

            this.tableData = list;
            this.page = pagination.current;
            this.total = pagination.total;
            this.loading = false;
          } else {
            this.$message.error(data.msg);
          }

          let height = $('.displayLayout').outerHeight() - ($('.demo-form-inline').outerHeight() + $('.el-table thead').height() + $('.el-pagination').outerHeight());
          $('.el-table__body-wrapper').css('height', height);
        })
      }
    },
    mounted() {
      if (!this.$$.checkLogin()) return false;

      this.getQuotationList();
    }
  }
</script>

<style scoped>
  @import "../../../../static/css/orderManagement.css";
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/quotationManagement.vue